import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { POSTS_PER_PAGE, PUBLISHED } from '../data/posts';
export function Blog() {
  const [params] = useSearchParams();
  const pageCount = Math.max(1, Math.ceil(PUBLISHED.length / POSTS_PER_PAGE));
  const requested = Number(params.get('page') ?? '1');
  const page = Number.isFinite(requested) ? Math.min(Math.max(1, Math.trunc(requested)), pageCount) : 1;
  const start = (page - 1) * POSTS_PER_PAGE;
  const slice = PUBLISHED.slice(start, start + POSTS_PER_PAGE);

  // The newest post leads the first page with its art; everything else reads as
  // a dated index, so the page scans as a list rather than a wall of cards.
  const lead = page === 1 ? slice[0] : undefined;
  const rows = lead ? slice.slice(1) : slice;
  return <>
      <header className="hero" data-id="element-336" data-mp="3bo1aj0bta872">
        {/* No .col-l here: this hero is one full-width column, and .col-l's
            divider would land on the frame's own right rule and double it. */}
        <div style={{
        width: '100%'
      }} data-id="element-337" data-mp="27472fnfqd9w1">
          <div className="lab-row" data-id="element-338" data-mp="2735ptej2gfc7">
            <span className="clabel" data-id="element-339" data-mp="27242aakv60dl">Signals</span>
          </div>
          <div className="head-block" data-id="element-340" data-mp="2bwgqsz1761w7">
            <h1 style={{
            maxWidth: '26ch',
            fontSize: 'clamp(30px,4vw,50px)'
          }} data-id="element-341" data-mp="2bxjg52ivfwa0">
              Field notes from <span className="g" data-id="element-342" data-mp="2fyli3r46amfo">the instruction layer.</span>
            </h1>
          </div>
          <div className="sub-block" data-id="element-343" data-mp="1j8uk3hwoah54">
            <p className="sub" style={{
            maxWidth: '64ch'
          }} data-id="element-344" data-mp="1o4t4kuevrf09">
              What we&rsquo;re learning about governing what AI models are told &mdash; the moment before the answer,
              where the obligations either rode or they didn&rsquo;t.
            </p>
          </div>
        </div>
      </header>

      {lead ? <div className="split blead" data-id="element-345" data-mp="33ltjvz2e7dcy">
          {/* Art leads on the left, flush to the frame, so the newest piece reads
              as the page's one featured item before any copy is scanned. */}
          <div className="sp-l bleadart" data-id="element-346" data-mp="18hlr0qtbp02u">
            {lead.hero ? <Link to={`/blog/${lead.slug}`} aria-label={lead.title} data-id="element-347" data-mp="14icwvkudf06r">
                <img className="bart" src={lead.hero} alt="" data-id="element-348" data-mp="1ihckcp65d91c" />
              </Link> : null}
          </div>
          <div className="sp-r bleadcopy" data-id="element-349" data-mp="1dhrq2s1x9ouy">
            <div className="bmeta" data-id="element-350" data-mp="1dj2qqj02mghu">
              <time dateTime={lead.date} data-id="element-351" data-mp="psoz2tleejns">{lead.dateLabel}</time>
              <span className="bcat" data-id="element-352" data-mp="psymc9f26cps">{lead.category}</span>
            </div>
            <h2 style={{
          maxWidth: 'none',
          marginTop: 18
        }} data-id="element-353" data-mp="kux57u170ngy">
              <Link className="btitle" to={`/blog/${lead.slug}`} data-id="element-354" data-mp="zi8hjy578bi4">
                {lead.title}
              </Link>
            </h2>
            <p className="lede" style={{
          marginTop: 20
        }} data-id="element-355" data-mp="uqqp5yh8rj8r">
              {lead.excerpt}
            </p>
            <p style={{
          marginTop: 26
        }} data-id="element-356" data-mp="70wennkea6ro">
              <Link className="slink" to={`/blog/${lead.slug}`} data-id="element-357" data-mp="6zurwlu0nvu4">
                Read it &rarr;
              </Link>
            </p>
          </div>
        </div> : null}

      <div className="blist" data-id="element-358" data-mp="2dp54d4l6dwln">
        {rows.map(post => <Link className="brow" key={post.slug} to={`/blog/${post.slug}`} data-id="element-359" data-mp="2ihg2c1wcv8bk">
            <div className="bmeta" data-id="element-360" data-mp="24q1mu51npp99">
              <time dateTime={post.date} data-id="element-361" data-mp="24r2wc530y3ov">{post.dateLabel}</time>
              <span className="bcat" data-id="element-362" data-mp="28r3kwiju7v9n">{post.category}</span>
            </div>
            <div data-id="element-363" data-mp="28p0l56svunrq">
              <h3 data-id="element-364" data-mp="2wh7f5zb4yinz">{post.title}</h3>
              <p data-id="element-365" data-mp="2wi91x11iktlj">{post.excerpt}</p>
            </div>
          </Link>)}
      </div>

      {pageCount > 1 ? <nav className="pager" aria-label="Signals pages" data-id="element-366" data-mp="31fiqkeh2x18b">
          {page > 1 ? <Link to={`/blog?page=${page - 1}`} data-id="element-367" data-mp="2nfho4ul61lqq">&larr; Newer</Link> : <span className="off" data-id="element-368" data-mp="2sekqu8dobfvj">&larr; Newer</span>}
          <span className="count" data-id="element-369" data-mp="1c144k1xg3sgi">
            Page {String(page).padStart(2, '0')} / {String(pageCount).padStart(2, '0')}
          </span>
          {page < pageCount ? <Link to={`/blog?page=${page + 1}`} data-id="element-370" data-mp="1h1ia9dbkqqbd">Older &rarr;</Link> : <span className="off" data-id="element-371" data-mp="1wbf170xle49e">Older &rarr;</span>}
        </nav> : null}

      <CtaBand data-id="element-372" data-mp="1ric6uqkzqqs5" />
      <Ledger data-id="element-373" data-mp="1rhszg3syvksd" />
    </>;
}